// Modules List
export const MODULES = {
  INFORMATION: "About Us",
  EVENT: "Event",
  BOOKING: "Booking",
  MEMBER: "Member",
  BUSINESS: "Business",
  BUSINESS_CATEGORY: "Business Category",
  BUSINESS_SUB_CATEGORY: "Business Subcategory",
  MATRIMONIAL: "Matrimonial",
  ADVERTISEMENTS: "Advertisement",
  BANNER: "Banner",
  ADMIN: "Admin",
  ROLE: "Role & Permission",
  POST: "Post",
  LOCATION: "Location",
  DASHBOARD: "Dashboard",
  COMMITTEE: "Committee",
  TRUSTEE: "Trustees",
  SETTING: "Setting",
  DISTRICT: "District",
  TALUKA: "Taluka",
  VILLAGE: "Village",
  EVENT_BOOKING: "Event Booking",
  QR_TEMPLATE: "Qr Template",
  EVENT_ATTENDANCE: "Event Attendance",
  AMENITY: "Amenity",
  OCCASION: "Occasion",
  RESERVE_DATE: "Reserve Date",
  AMENITY_BOOKING: "Amenity Booking",
  ADD_ONS: "Add Ons",
  SAMAJ_BOOKING: "Samaj Booking",
};

// Module Permission
export const ACCESS_TYPES = {
  READ: "read_access",
  WRITE: "write_access",
  DELETE: "delete_access",
};

export const AuthRouteJson = {
  dashboard: "/dashboard",
  admins: "/admins",
  roles: "/roles",
  members: "/members",
  events: "/events",
  event_bookings: "/event_bookings",
  qr_template: "/qr_template",
  event_attendance: "/event_attendance",
  posts: "/posts",
  booking: "/booking",
  business: "/business",
  business_category: "/business_category",
  business_subcategory: "/business_subcategory",
  matrimonial: "/matrimonial",
  advertisement: "/advertisement",
  aboutus: "/about-us",
  profile: "/profile",
  signin: "/authentication/sign-in",
  forgotpassword: "/authentication/forgot-password",
  resetpassword: "/authentication/reset-password",
  otp: "/authentication/otp",
  location: "/location",
  banner: "/banner",
  committee: "/committee",
  trustee: "/trustee",
  documents: "/document",
  setting: "/setting",
  district: "/district",
  taluka: "/taluka",
  village: "/village",
  amenity: "/amenity",
  occasion: "/occasion",
  reserve_date: "/reserve/date",
  amenity_booking: "/amenity/booking/list",
  add_ons: "/add/ons",
  samaj_booking: "/samaj/booking",
};

export const INFORMATION = "information/";
export const ADMIN = "admin/";
export const ADVERTISEMENT = "advertisement/";
export const BOOKING = "booking/";
export const BUSINESS = "business/";
export const BUSINESS_CATEGORY = "business_category/";
export const BUSINESS_SUBCATEGORY = "business_subcategory/";
export const EVENT = "event/";
export const QRTEMPLATE = "qr_template/";
export const MATRIMONIAL = "matrimonial/";
export const POST = "post/";
export const ROLE = "role/";
export const UTILS = "utils/";
export const MODULE = "module/";
export const DISTRICT = "district/";
export const TALUKA = "taluka/";
export const VILLAGE = "village/";
export const DASHBOARD = "dashboard/";
export const BANNER = "banner/";
export const COMMITTEE = "committee/";
export const TRUSTEE = "trustee/";
export const PAGE = "page/";
export const SETTING = "setting/";
export const EVENT_BOOKING = "event_booking/";
export const EVENT_ATTENDANCE = "event_attendances/";
export const AMENITY = "amenity/";
export const OCCASION = "occasion/";
export const RESERVE_DATE = "reserve_date/";
export const ADD_ONS = "amenity_addon/";

export const INFORMATIONURL = {
  GET: `${INFORMATION}get`,
  UPDATE: `${INFORMATION}update`,
};

export const ADMINURL = {
  LIST: `${ADMIN}get/list`,
  ADD: `${ADMIN}add`,
  GET: (id) => `${ADMIN}get/${id}`,
  UPDATE: `${ADMIN}update`,
  DELETE: (id) => `${ADMIN}delete/${id}`,
  MEMBER_LIST: `${ADMIN}get/member/list`,
  MEMBER_ADD: `${ADMIN}member/add`,
  MEMBER_GET: (id) => `${ADMIN}get/member/${id}`,
  MEMBER_UPDATE: `${ADMIN}member/update`,
  MEMBER_DELETE: (id) => `${ADMIN}member/delete/${id}`,
  SIGN_IN: `${ADMIN}sign_in`,
  FORGOT_PASSWORD: `${ADMIN}forgot_password`,
  RESET_PASSWORD: `${ADMIN}reset_password`,
  SIGN_OUT: `${ADMIN}sign_out`,
  UPDATE_PROFILE: `${ADMIN}update_profile`,
  PROFILE: `${ADMIN}profile`,
  CHANGE_PASSWORD: `${ADMIN}change_password`,
  ADMIN_GET_ALL_LIST: `${ADMIN}get/all/list`,
  MEMBER_VERIFY: (id) => `${ADMIN}member/verify/${id}`,
  MEMBER_PHONE_VIEW_LIMIT_RESET: (id) => `${ADMIN}member/reset/${id}`,
  SUB_MEMBER_LIST: `${ADMIN}get/sub_member/list`,
  SUB_MEMBER: `${ADMIN}get/sub_member`,
  UNVERIFIED_MEMBERS: `${ADMIN}get/unverified/member/list`,
};

export const ADVERTISEMENTURL = {
  LIST: `${ADVERTISEMENT}list`,
  ADD: `${ADVERTISEMENT}add`,
  GET: (id) => `${ADVERTISEMENT}get/${id}`,
  UPDATE: `${ADVERTISEMENT}update`,
  DELETE: (id) => `${ADVERTISEMENT}delete/${id}`,
};

export const BOOKINGURL = {
  LIST: `${BOOKING}list`,
  ADD: `${BOOKING}add`,
  GET: (id) => `${BOOKING}get/${id}`,
  UPDATE: `${BOOKING}update`,
  DELETE: (id) => `${BOOKING}delete/${id}`,
};

export const BUSINESSURL = {
  LIST: `${BUSINESS}list`,
  ADD: `${BUSINESS}add`,
  GET: (id) => `${BUSINESS}get/${id}`,
  UPDATE: `${BUSINESS}update`,
  DELETE: (id) => `${BUSINESS}delete/${id}`,
  VERIFY: (id) => `${BUSINESS}verify/${id}`,
};

export const BUSINESS_CATEGORYURL = {
  ADD: `${BUSINESS_CATEGORY}add`,
  GET: (id) => `${BUSINESS_CATEGORY}get/${id}`,
  UPDATE: `${BUSINESS_CATEGORY}update`,
  DELETE: (id) => `${BUSINESS_CATEGORY}delete/${id}`,
  LIST: `${BUSINESS_CATEGORY}list`,
};

export const BUSINESS_SUBCATEGORYURL = {
  ADD: `${BUSINESS_SUBCATEGORY}add`,
  GET: (id) => `${BUSINESS_SUBCATEGORY}get/${id}`,
  UPDATE: `${BUSINESS_SUBCATEGORY}update`,
  DELETE: (id) => `${BUSINESS_SUBCATEGORY}delete/${id}`,
  LIST: `${BUSINESS_SUBCATEGORY}list`,
};

export const SETTINGURL = {
  LIST: `${SETTING}list`,
  ADD: `${SETTING}add`,
  GET: (id) => `${SETTING}get/${id}`,
  UPDATE: `${SETTING}update`,
  DELETE: (id) => `${SETTING}delete/${id}`,
};

export const EVENTURL = {
  LIST: `${EVENT}list`,
  ADD: `${EVENT}add`,
  GET: (id) => `${EVENT}get/${id}`,
  UPDATE: `${EVENT}update`,
  DELETE: (id) => `${EVENT}delete/${id}`,
};
export const QRTEMPLATEURL = {
  LIST: `${QRTEMPLATE}list`,
  ADD: `${QRTEMPLATE}add`,
  GET: (id) => `${QRTEMPLATE}get/${id}`,
  UPDATE: `${QRTEMPLATE}update`,
  DELETE: (id) => `${QRTEMPLATE}delete/${id}`,
};

export const MATRIMONIALURL = {
  LIST: `${MATRIMONIAL}list`,
  ADD: `${MATRIMONIAL}add`,
  GET: (id) => `${MATRIMONIAL}get/${id}`,
  UPDATE: `${MATRIMONIAL}update`,
  DELETE: (id) => `${MATRIMONIAL}delete/${id}`,
  VERIFY: (id) => `${MATRIMONIAL}verify/${id}`,
};

export const POSTURL = {
  LIST: `${POST}list`,
  ADD: `${POST}add`,
  GET: (id) => `${POST}get/${id}`,
  UPDATE: `${POST}update`,
  DELETE: (id) => `${POST}delete/${id}`,
};

export const ROLEURL = {
  LIST: `${ROLE}list`,
  ADD: `${ROLE}add`,
  GET: (id) => `${ROLE}get/${id}`,
  UPDATE: `${ROLE}update`,
  DELETE: (id) => `${ROLE}delete/${id}`,
  ADMIN_ROLE_LIST: `${ROLE}list`,
};

export const PLAIN_TEXT = true;

export const UTILSURL = {
  UPLOAD_MULTIPLE: `${UTILS}upload/multiple`,
  REMOVE_IMAGE: `${UTILS}remove/image`,
  UPDATE_STATUS: `${UTILS}update/status`,
  GET_JSON: `${UTILS}get/json`,
};
export const MODULEURL = {
  LIST: `${MODULE}list`,
};

export const DISTRICTURL = {
  ADD: `${DISTRICT}add`,
  ADD_DISTRICT: `${DISTRICT}add_district`,
  UPDATE: `${DISTRICT}update`,
  DELETE: (id) => `${DISTRICT}delete/${id}`,
  GET: (id) => `${DISTRICT}get/${id}`,
};

export const TALUKAURL = {
  ADD: `${TALUKA}add`,
  UPDATE: `${TALUKA}update`,
  DELETE: (id) => `${TALUKA}delete/${id}`,
  GET: (id) => `${TALUKA}get/${id}`,
};

export const VILLAGEURL = {
  ADD: `${VILLAGE}add`,
  UPDATE: `${VILLAGE}update`,
  DELETE: (id) => `${VILLAGE}delete/${id}`,
  GET: (id) => `${VILLAGE}get/${id}`,
};

export const DASHBOARDURL = {
  GET_COUNT: `${DASHBOARD}count`,
  GET_BOOKING_LIST: `${DASHBOARD}bookinglist`,
  GET_MEMBER_LIST: `${DASHBOARD}last/member`,
  GET_BUSINESS_LIST: `${DASHBOARD}last/business`,
  GET_EVENT_LIST: `${DASHBOARD}eventlist`,
};

export const BANNERURL = {
  LIST: `${BANNER}list`,
  ADD: `${BANNER}add`,
  GET: (id) => `${BANNER}get/${id}`,
  UPDATE: `${BANNER}update`,
  DELETE: (id) => `${BANNER}delete/${id}`,
};

export const AMENITYURL = {
  LIST: `${AMENITY}list`,
  AVAILABLE: `${AMENITY}available`,
  ADD: `${AMENITY}add`,
  BOOK: `${AMENITY}book`,
  BOOKING_LIST: `${AMENITY}booking/list`,
  UPDATE_BOOKING: `${AMENITY}booking/update`,
  CALENDER_LIST: `${AMENITY}booking/calendar`,
  SETTLE_DEPOSIT: `${AMENITY}booking/settle`,
  OPTION: `${AMENITY}options`,
  GET: (id) => `${AMENITY}get/${id}`,
  UPDATE: `${AMENITY}update`,
  DELETE: (id) => `${AMENITY}delete/${id}`,
};

export const OCCASIONURL = {
  LIST: `${OCCASION}list`,
  ADD: `${OCCASION}add`,
  OPTION: `${OCCASION}options`,
  GET: (id) => `${OCCASION}get/${id}`,
  UPDATE: `${OCCASION}update`,
  DELETE: (id) => `${OCCASION}delete/${id}`,
};

export const RESERVEDATEURL = {
  LIST: `${RESERVE_DATE}list`,
  ADD: `${RESERVE_DATE}add`,
  GET: (id) => `${RESERVE_DATE}get/${id}`,
  UPDATE: `${RESERVE_DATE}update`,
  DELETE: (id) => `${RESERVE_DATE}delete/${id}`,
};

export const ADDONSURL = {
  LIST: `${ADD_ONS}list`,
  ADD: `${ADD_ONS}add`,
  OPTION: `${ADD_ONS}options`,
  GET: (id) => `${ADD_ONS}get/${id}`,
  UPDATE: `${ADD_ONS}update`,
  DELETE: (id) => `${ADD_ONS}delete/${id}`,
};
export const COMMITTEEURL = {
  LIST: `${COMMITTEE}list`,
  ADD: `${COMMITTEE}add`,
  GET: (id) => `${COMMITTEE}get/${id}`,
  UPDATE: `${COMMITTEE}update`,
  DELETE: (id) => `${COMMITTEE}delete/${id}`,
};

export const PAGEURL = {
  LIST: `${PAGE}list`,
};

export const EVENTBOOKINGURL = {
  LIST: `${EVENT_BOOKING}list`,
  ADD: `${EVENT_BOOKING}add`,
  UPDATE: `${EVENT_BOOKING}update_status`,
};
export const EVENTATTENDANCEURL = {
  LIST: `${EVENT_ATTENDANCE}list`,
};

export let statusData = [
  {
    label: "Active",
    value: "1",
  },
  {
    label: "Inactive",
    value: "0",
  },
];

export let BookingTagData = [
  { label: "AGRT Functions" },
  { label: "Marriage & Other Functions of Members" },
  { label: "Non Member Functions" },
];

// table search constant
export const SEARCH_INPUT_TYPES = {
  TEXT: "text",
  SELECT: "select",
  DATE: "date",
  AUTO_COMPLETE: "autoComplete",
  TIME: "time",
};

// Trustee
export const TRUSTEE_URL = {
  LIST: `${TRUSTEE}list`,
  ADD: `${TRUSTEE}add`,
  GET: (id) => `${TRUSTEE}get/${id}`,
  UPDATE: `${TRUSTEE}update`,
  DELETE: (id) => `${TRUSTEE}delete/${id}`,
};

// Force Update Data
export let ForceUpdateData = [
  {
    label: "True",
    value: 1,
  },
  {
    label: "False",
    value: 0,
  },
];
